import React, { useState } from 'react';
const categories = ['Alle', 'Innenraum', 'Fassade', 'Vorher/Nachher', 'Varianten'];
const items = [{
  id: 1,
  title: 'Loft Berlin',
  category: 'Innenraum',
  image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80&w=800'
}, {
  id: 2,
  title: 'Villa München',
  category: 'Fassade',
  image: 'https://images.unsplash.com/photo-1600596542815-3ad19fb2a258?auto=format&fit=crop&q=80&w=800'
}, {
  id: 3,
  title: 'Penthouse Hamburg',
  category: 'Innenraum',
  image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80&w=800'
}, {
  id: 4,
  title: 'Sanierung Köln',
  category: 'Vorher/Nachher',
  image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&q=80&w=800'
}, {
  id: 5,
  title: 'Büro Frankfurt',
  category: 'Varianten',
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800'
}, {
  id: 6,
  title: 'Stadthaus Wien',
  category: 'Fassade',
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=800'
}, {
  id: 7,
  title: 'Apartment Zürich',
  category: 'Innenraum',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=800'
}, {
  id: 8,
  title: 'Residenz Salzburg',
  category: 'Varianten',
  image: 'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?auto=format&fit=crop&q=80&w=800'
}];
export function Gallery() {
  const [activeCategory, setActiveCategory] = useState('Alle');
  const filteredItems = activeCategory === 'Alle' ? items : items.filter(item => item.category === activeCategory);
  return <section id="gallery" className="py-24 bg-[#FAFAFA]" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12 gap-6" data-id="element-82">
          <h2 className="text-3xl sm:text-4xl font-semibold text-black" data-id="element-83">
            Ausgewählte Projekte
          </h2>

          <div className="flex flex-wrap justify-center gap-2" data-id="element-84">
            {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${activeCategory === category ? 'bg-black text-white' : 'bg-white text-neutral-500 border border-neutral-200 hover:border-neutral-300 hover:text-black'}`} data-id="element-85">
                {category}
              </button>)}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-86">
          {filteredItems.map(item => <div key={item.id} className="group relative aspect-[4/3] overflow-hidden rounded-xl bg-neutral-100 cursor-pointer" data-id="element-87">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100" data-id="element-88" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-89">
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-90">
                  <p className="text-white font-medium text-lg" data-id="element-91">{item.title}</p>
                  <p className="text-white/70 text-sm font-light" data-id="element-92">
                    {item.category}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}